import {BaseModel} from "../base/BaseModel";
import {FirmTypeEnum} from "./FirmModel";
import {InvoiceAddressModel} from "../invoiceAddress/InvoiceAddressModel";
import {CreditCardModel} from "../creditCard/CreditCardModel";
import {VehicleModel} from "../vehicle/VehicleModel";
import {SovosModel} from "../sovos/SovosModel";
import {LogModel} from "../log/LogModel";
import {AgentCommissionModel} from "../agent/AgentCommissionModel";
import {DriverModel} from "./DriverModel";
import {VehiclePriceModel} from "../vehiclePrice/VehiclePriceModel";
import {TripModel} from "../trip/TripModel";
import {AgentCreditInfoModel} from "../agent/AgentCreditInfoModel";
import {TagDTO} from "../tag/TagModel";

export enum UserTypeEnum {
    Passenger = 0,
    Driver = 1,
    Firm = 2,
    AgencyAdminUser = 3,
    Admin = 4,
    AgencyUser = 5,
    AgencyPassenger = 6,
    AgencyAdmin = 7,
    CountryAdmin = 8,
    AirportGreeter = 9
}

export type UserTypeInfo = {
    name: string;
    color: string;
};

export const userTypesWithLang: Record<UserTypeEnum, UserTypeInfo> = {
    [UserTypeEnum.Passenger]: {
        name: "agentAdmin.userTypes.passenger",
        color: "success",
    },
    [UserTypeEnum.Driver]: {
        name: "agentAdmin.userTypes.driver",
        color: "primary",
    },
    [UserTypeEnum.Firm]: {
        name: "agentAdmin.userTypes.firm",
        color: "warning",
    },
    [UserTypeEnum.Admin]: {
        name: "agentAdmin.userTypes.admin",
        color: "danger",
    },
    [UserTypeEnum.AgencyUser]: {
        name: "agentAdmin.userTypes.agencyUser",
        color: "info",
    },
    [UserTypeEnum.AgencyPassenger]: {
        name: "agentAdmin.userTypes.agencyPassenger",
        color: "secondary",
    },
    [UserTypeEnum.AgencyAdminUser]: {
        name: "agentAdmin.userTypes.agencyAdminUser",
        color: "dark",
    },
    [UserTypeEnum.AgencyAdmin]: {
        name: "agentAdmin.userTypes.agencyAdmin",
        color: "info",
    },
    [UserTypeEnum.CountryAdmin]: {
        name: "agentAdmin.userTypes.countryAdmin",
        color: "info",
    },
    [UserTypeEnum.AirportGreeter]: {
        name: "agentAdmin.userTypes.airportGreeter",
        color: "primary",
    },
};


export const userTypeKeysWithLang: Record<string, UserTypeEnum> = {
    "agentAdmin.userTypes.passenger": UserTypeEnum.Passenger,
    "agentAdmin.userTypes.driver": UserTypeEnum.Driver,
    "agentAdmin.userTypes.firm": UserTypeEnum.Firm,
    "agentAdmin.userTypes.admin": UserTypeEnum.Admin,
    "agentAdmin.userTypes.agencyUser": UserTypeEnum.AgencyUser,
    "agentAdmin.userTypes.agencyPassenger": UserTypeEnum.AgencyPassenger,
    "agentAdmin.userTypes.agencyAdminUser": UserTypeEnum.AgencyAdminUser,
    "agentAdmin.userTypes.agencyAdmin": UserTypeEnum.AgencyAdmin,
    "agentAdmin.userTypes.countryAdmin": UserTypeEnum.CountryAdmin,
    "agentAdmin.userTypes.airportGreeter": UserTypeEnum.AirportGreeter,
};

export const userTypes: Record<UserTypeEnum, UserTypeInfo> = {
    [UserTypeEnum.Passenger]: {name: "Yolcu", color: "success"},
    [UserTypeEnum.Driver]: {name: "Sürücü", color: "primary"},
    [UserTypeEnum.Firm]: {name: "Firma", color: "warning"},
    [UserTypeEnum.Admin]: {name: "Admin", color: "danger"},
    [UserTypeEnum.AgencyUser]: {name: "Acenta Kullanıcısı", color: "info"},
    [UserTypeEnum.AgencyPassenger]: {name: "Acenta Yolcusu", color: "secondary"},
    [UserTypeEnum.AgencyAdminUser]: {name: "Acenta Admin", color: "dark"},
    [UserTypeEnum.AgencyAdmin]: {name: "Acenta", color: "info"},
    [UserTypeEnum.CountryAdmin]: {name: "Ülke Admin", color: "info"},
    [UserTypeEnum.AirportGreeter]: {name: "Havalimanı Karşılamacı", color: "primary"}

};

export const userTypeKeys: Record<string, UserTypeEnum> = {
    "Yolcu": UserTypeEnum.Passenger,
    "Sürücü": UserTypeEnum.Driver,
    "Firma": UserTypeEnum.Firm,
    "Acenta": UserTypeEnum.AgencyAdmin,
    "Admin": UserTypeEnum.Admin,
    "Ülke Admin": UserTypeEnum.CountryAdmin,
    "Havalimanı Karşılamacı": UserTypeEnum.AirportGreeter,

};


export interface UserModel extends BaseModel {
    name?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    profilePic?: string;
    blocked?: boolean;
    type?: UserTypeEnum;
    identity?: string;
    status?: number;
    iban?: string;
    ibanOwnerName?: string;
    firmId?: number;
    agentId?: string;
    firmName?: string;
    firmType?: number;
    b2d2No?: string;
    uetdsUsername?: string;
    userKey?: string;
    nationality?: string;
    gender?: string;
    apiKey?: string;
    secret?: string;
    password?: string;
    contactPassenger?: boolean;
    isSovosUser?: boolean;
    deleted?: boolean;
    tripVehiclePlate?: string;
    creditInfo?: AgentCreditInfoModel;
}

export interface UserSearchDTO {
    phoneNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    identity?: string;
    status?: number;
    firmName?: string;
    userKey?: string;
    b2d2No?: string;
    uetdsUsername?: string;
    firmType?: FirmTypeEnum;
    type?: UserTypeEnum;
    minUsedCreditAmount?: number;
    maxUsedCreditAmount?: number;
}

export interface UserPageData {
    content?: UserModel[];
    size?: number;
    totalPages?: number;
    totalElements?: number;
    number?: number;
}

export interface UserDetailDTO extends UserModel {
    zuppara?: number;
    driverBalance?: number;
    driverLicence?: string;
    criminalReport?: string;
    psycho?: string;
    src?: string;
    taxDepartment?: string;
    taxId?: string;
    address?: string;
    b2d2?: string;
    b2d2OwnerName?: string;
    insurance?: string;
    travelAgency?: string;
    travelAgencyNo?: string;
    uetdsPassword?: string;
    balance?: number;
    driverRate?: number;
    creditCards?: CreditCardModel[];
    invoiceAddresses?: InvoiceAddressModel[];
    statistic?: UserStatisticDTO;
    driverLanguages?: string[];
    driverVehicles?: VehicleModel[];
    driverSovos?: SovosModel[];
    driverLogs?: LogModel[];
    agentStatistic?: UserStatisticDTO;
    agentAdmins?: UserModel[];
    agentCommissions?: AgentCommissionModel[];
    firmDrivers?: DriverModel[];
    firmVehicles?: VehicleModel[];
    firmSovos?: SovosModel[];
    driverTrips?: TripModel[];
    passengerTrips?: TripModel[];
    firmServiceRegions?: VehiclePriceModel[];
    creditInfo?: AgentCreditInfoModel;
    serviceCountryName?: string;
    serviceCountryId?: number;
    tags?: TagDTO[];


}

export interface UserStatisticDTO {
    callNumber?: number;
    tripNumber?: number;
    b2bTripNumber?: number;
    requestNumber?: number;
    averagePoint?: number;
    uetdsTripNumber?: number;
}

export enum StatisticTypeEnum {
    TRIP = 0,
    B2B_TRIP = 1,
    REQUEST = 2,
    COMMENT = 3,
    UETDS_TRIP = 4,
    CALL = 5,
    VEHICLE_CALL = 6,
    OFFER = 7
}
